import { sharedTracker } from '../Tracker';
import events from '../events';

export const trackSubscriptionReactivated = () => sharedTracker
	.trackSubscriptionAction( {
		action: events.subscription.SUBSCRIPTION_REACTIVATED
	} );
